/**
 *
 * ProgressBar
 *
 */

import React, { Fragment } from "react"
import { Tooltip } from "antd"
import "./index.less"
// import PropTypes from 'prop-types';
// import styled from 'styled-components';

/* eslint-disable react/prefer-stateless-function */
class ProgressBar extends React.Component {
  render() {
    const { props } = this

    return (
      <div
        className="ProgressBarComponent"
        style={props.style ? { ...props.style } : {}}>
        <div
          className={`ProgressBarComponent-bloqueLineas${
            props.custom && props.custom.value_visible ? "Grid" : ""
          }`}>
          <div className="ProgressBarComponent-lineValues">
            <div className="ProgressBarComponent-lineValues-plomo" />
            {props.custom ? (
              <Tooltip title={props.custom.value_visible}>
                <div
                  className="ProgressBarComponent-lineValues-custom"
                  style={{
                    backgroundColor: props.custom.color,
                    width: `${props.custom.value}%`,
                    borderRadius: 5,
                  }}
                />
              </Tooltip>
            ) : (
              <div
                className="ProgressBarComponent-container"
                style={{
                  gridTemplateColumns: `${
                    props.values.low != "N/A" ? props.values.low : "0%"
                  } ${
                    props.values.middle != "N/A" ? props.values.middle : "0%"
                  } ${props.values.top != "N/A" ? props.values.top : "0%"}`,
                }}>
                <Tooltip title={props.values.low}>
                  <div className="ProgressBarComponent-lineValues-low" />
                </Tooltip>
                <Tooltip title={props.values.middle}>
                  <div className="ProgressBarComponent-lineValues-middle" />
                </Tooltip>
                <Tooltip title={props.values.top}>
                  <div className="ProgressBarComponent-lineValues-top" />
                </Tooltip>
              </div>
            )}
          </div>
          {props.custom && props.custom.value_visible && (
            <div
              className="ProgressBarComponent-bloqueLineasGrid-info"
              style={{ color: props.custom.color, fontWeight: "normal" }}>
              {" "}
              {props.custom.value_visible}{" "}
            </div>
          )}
        </div>
      </div>
    )
  }
}

ProgressBar.propTypes = {}

export default ProgressBar
